var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg absolute w-full h-full left-0 bg-contain bg-no-repeat",style:(`background-position: top center; background-image: url(${require('assets/images/shapes/shape-7_gray-100.png')}); /* transform: rotateY(180deg); */`)})
}
var staticRenderFns = []

export { render, staticRenderFns }